import FORM_AUDIENCE_TYPE from './FormAudienceType';
import FORM_ASSIGNMENT_TYPE from './FormAssignmentType';
import FORM_TYPE from './FormType';
import {wizardTemplateRules} from '../utility/templateWizardRules';

// AD-2537: the choices a school makes in the form wizard. The template screen shows which of them
// the wizard offers a template to, by the wizard's own rules, so a template a super admin makes
// works exactly as the templates that came with Admicity.
export const WIZARD_CHOICES = [
    {
        label: 'parents with an Admicity account',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.parentsForChildCompletion, parentAccountType: 'with-account', formType: FORM_TYPE.email}
    },
    {
        label: 'parents without an Admicity account',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.parentsForChildCompletion, parentAccountType: 'without-account', formType: FORM_TYPE.email}
    },
    {
        label: 'parents of an applicant with Applied or Offered status',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.parentsForChildCompletion, parentAccountType: 'applicant-status', formType: FORM_TYPE.email}
    },
    {
        label: 'application and acceptance forms',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.parentsForChildCompletion, parentAccountType: 'applicant-status', formType: FORM_TYPE.application}
    },
    {
        label: 'parents, on self-service forms',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.parentsForChildCompletion, parentAccountType: 'with-account', formType: FORM_TYPE.selfService}
    },
    {
        label: 'students',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.students, formType: FORM_TYPE.email}
    },
    {
        label: 'employees',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.employees, formType: FORM_TYPE.email, linkToStudents: false}
    },
    {
        label: 'employees linked to a student',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.employees, formType: FORM_TYPE.email, linkToStudents: true}
    },
    {
        label: 'employees, on self-service forms',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.employees, formType: FORM_TYPE.selfService}
    },
    {
        label: 'employees linked to a student, on self-service forms',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.employees, formType: FORM_TYPE.selfService, linkToStudents: true}
    },
    {
        label: 'employees linked to an employee, on self-service forms',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.employees, formType: FORM_TYPE.selfService, linkToEmployees: true}
    },
    {
        label: 'enquiries',
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.enquiries, formType: FORM_TYPE.email}
    },
    {
        label: "children's previous schools",
        context: {recipientTypeAudience: FORM_AUDIENCE_TYPE.previousSchool, formType: FORM_TYPE.email}
    },
    {
        label: 'external recipients',
        context: {
            recipientTypeAudience: FORM_AUDIENCE_TYPE.externalUsers,
            formType: FORM_TYPE.email,
            effectiveRecipientAssignmentTypeNum: FORM_ASSIGNMENT_TYPE.students
        }
    },
];

/**
 * The wizard choices a template is offered to. The template needs its type, its category name and its
 * parent category name, as the wizard reads them.
 */
export const wizardChoicesFor = (template) => WIZARD_CHOICES
    .filter(({context}) => {
        const rules = wizardTemplateRules(context);
        return rules.filterAdmicityTemplateByFormType(template) && rules.matchesTemplateAudience(template);
    })
    .map(({label}) => label);

/**
 * The template the wizard would read for a type and a category chosen on the template screen: the
 * chosen category's name, and its parent's name when it is a subcategory.
 */
export const templateForCategory = (type, categoryId, categories, audiences = []) => {
    const chosen = (categories ?? []).find(category => category.id === categoryId);
    const parent = chosen?.parentId ? categories.find(category => category.id === chosen.parentId) : null;

    return {
        type,
        audiences,
        category: chosen?.name ?? '',
        parentCategory: parent?.name ?? ''
    };
};
